import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, ListItemText, Typography } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

interface IdeationMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
  disableEdit?: boolean;
  disableDelete?: boolean;
  editLabel?: string;
  deleteLabel?: string;
  onDownload?: () => void;
  disableDownload?: boolean;
}

const IdeationMenu: React.FC<IdeationMenuProps> = ({
  onEdit,
  onDelete,
  disableEdit = false,
  disableDelete = false,
  onDownload,
  disableDownload = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    onEdit?.();
    handleClose();
  };

  const handleDeleteClick = () => {
    onDelete?.();
    handleClose();
  };

  return (
    <Box>
      <IconButton
        aria-label="more options"
        aria-controls={open ? 'ideation-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          color: '#666',
          padding: '4px',
          backgroundColor: 'transparent',
          border: open ? '1px solid #1A55F9' : '1px solid transparent',
          borderRadius: '6px',
          transition: 'border-color 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderColor: open ? '#1A55F9' : 'rgba(0,0,0,0.2)',
          },
        }}
      >
        <MoreHoriz sx={{ fontSize: '20px' }} />
      </IconButton>

      <Menu
        id="ideation-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disablePortal={false}
        container={() => document.body}
        slotProps={{
          paper: {
            sx: {
              minWidth: '200px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              borderRadius: '8px',
              mt: 0.5,
            },
            style: {
              zIndex: 10000,
            },
          },
          root: {
            style: {
              zIndex: 10000,
            },
          },
          backdrop: {
            sx: {
              zIndex: 9999,
            },
          },
        }}
        MenuListProps={{
          sx: {
            py: 0,
          },
        }}
      >
        <MenuItem
          onClick={handleEditClick}
          disabled={disableEdit}
          sx={{
            py: 1.2,
            '&:hover': {
              backgroundColor: '#F0F0F0',
            },
            '&.Mui-disabled': {
              opacity: 0.6,
              cursor: 'not-allowed',
            },
          }}
        >
          <ListItemText>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Rename Process</Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={onDownload}
          disabled={disableDownload}
          sx={{
            py: 1.2,
            '&:hover': {
              backgroundColor: '#F0F0F0',
            },
            '&.Mui-disabled': {
              opacity: 0.6,
              cursor: 'not-allowed',
            },
          }}
        >
          <ListItemText>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Download Report</Typography>
          </ListItemText>
        </MenuItem>

        <MenuItem
          onClick={handleDeleteClick}
          disabled={disableDelete}
          sx={{
            py: 1.2,
            '&:hover': {
              backgroundColor: '#FFEBEE',
            },
            '&.Mui-disabled': {
              opacity: 0.6,
              cursor: 'not-allowed',
            },
          }}
        >
          <ListItemText>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#EF4444' }}>
              Delete Ideation
            </Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default IdeationMenu;
